import { Typography } from "@mui/material";
import { CSSProperties, ReactNode } from "react";
import CottageIcon from '@mui/icons-material/Cottage';

export default function WindowPattern ({ children, path, icon, style }: { children?: any, path: string, icon?: ReactNode, style?: CSSProperties }) {
    return (
        <div style={{ background: 'var(--color-white)', height: style?.height ? style.height : '68vh', margin: '10px', display: 'flex', flexDirection: 'column', borderRadius: '15px 15px', overflowY: 'hidden', overflowX: 'hidden' }}>
            <div style={{ background: 'rgba(0, 0, 0, 0.05)', height: '56px' }}>
                <div style={{ margin: '0px 0px 0px 15px', display: 'flex', alignItems: 'center', height: '50px', color: 'var(--color-blue)' }}>
                    <div style={{ margin: '0px 15px 0px 0px' }}>
                        {icon ? icon : <CottageIcon />}
                    </div>
                    <Typography fontSize={'medium'} fontWeight={'bolder'}>{path}</Typography>
                </div>
            </div>
            <div style={{ margin: '10px', height: '100vh', overflow: 'auto', ...style }}>
                {children}
            </div>
        </div>
    )
}